(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-card/assets/javascripts/canvas/draw-win-anim.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-card/assets/javascripts/canvas/draw-win-anim.js');
"use strict";


const {
  easeOutBounce,
  remapTime,
  lerp
} = svs.bingo_react.components.bingoCard.canvas.Util;

const BINGO_PATH = new Path2D('M29.9,32.8c0,4.1-1.2,7.4-3.6,9.7-2.4,2.3-5.7,3.5-9.8,3.5H.2V1.7h15.2c4.6,0,8,1.1,10.2,3.3,2.3,2.2,3.4,5.1,3.4,8.9s-.4,3.7-1.2,5.3c-.8,1.6-1.9,2.7-3.3,3.5,1.8,1,3.2,2.3,4,3.9.9,1.6,1.3,3.7,1.3,6.3ZM10.8,10.9v8.1h3.6c1.1,0,2-.3,2.7-1,.7-.7,1-1.7,1-3s-.3-2.3-1-3c-.6-.7-1.5-1-2.7-1h-3.6ZM10.8,28v8.8h4c1.2,0,2.2-.4,2.9-1.2.8-.8,1.2-1.9,1.2-3.2s-.4-2.4-1.2-3.2c-.7-.8-1.7-1.2-2.9-1.2h-4ZM45.1,46h-10.7V1.7h10.7v44.3ZM61.1,19.8v26.2h-10.3V1.7h11l16.6,26.8V1.7h10.3v44.3h-10.6l-17.1-26.2ZM136.4,46h-10.3v-2.2c-1.1.9-2.4,1.6-4.1,2.1s-3.7.8-6.1.8c-3.4,0-6.6-.5-9.4-1.6-2.8-1.1-5.2-2.7-7.2-4.7-2-2-3.6-4.5-4.7-7.3-1.1-2.8-1.7-6-1.7-9.4s.5-6,1.6-8.8c1.1-2.8,2.6-5.2,4.6-7.3,2-2.1,4.4-3.8,7.2-5,2.9-1.2,6-1.9,9.5-1.9s4.6.3,6.5.8c2,.5,3.7,1.1,5.2,2,1.6.8,2.9,1.8,4.1,2.9,1.2,1.1,2.1,2.3,2.9,3.6l-8.4,6.1c-.5-.6-1-1.3-1.7-1.9-.6-.7-1.3-1.3-2.2-1.8-.8-.5-1.8-.9-2.9-1.2-1.1-.3-2.3-.5-3.7-.5s-3.3.3-4.8,1c-1.5.6-2.7,1.5-3.7,2.7-1,1.1-1.8,2.5-2.4,4-.6,1.6-.8,3.3-.8,5.2s.3,3.8.9,5.4c.6,1.6,1.5,3,2.6,4.2,1.1,1.1,2.4,2,3.9,2.6,1.5.6,3.2.9,4.9.9s4.5-.4,6.1-1.2c1.6-.8,2.7-1.5,3.4-2.2v-3.2h-6.6v-8.8h17.1v24.4ZM139.7,23.9c0-3.2.6-6.2,1.7-9,1.1-2.8,2.7-5.2,4.7-7.3,2-2.1,4.5-3.7,7.3-4.9,2.8-1.2,5.9-1.8,9.3-1.8s6.9.6,9.8,1.8c2.9,1.2,5.4,2.8,7.4,4.8,2,2,3.6,4.5,4.7,7.2,1.1,2.8,1.7,5.8,1.7,9s-.6,6.3-1.7,9.1c-1.1,2.8-2.6,5.3-4.6,7.4-2,2-4.4,3.7-7.3,4.9-2.9,1.2-6.1,1.8-9.6,1.8s-6.9-.6-9.8-1.7c-2.9-1.2-5.3-2.8-7.3-4.9-2-2-3.5-4.5-4.6-7.2-1.1-2.8-1.6-5.8-1.6-9.1ZM150.9,23.9c0,1.8.3,3.5.8,5.1.6,1.6,1.3,3,2.4,4.2,1.1,1.2,2.3,2.1,3.8,2.8,1.5.6,3.2,1,5,1s3.7-.3,5.2-1c1.5-.7,2.8-1.6,3.8-2.8,1-1.2,1.8-2.6,2.3-4.2.5-1.6.8-3.3.8-5.1s-.3-3.5-.8-5.1c-.6-1.6-1.3-2.9-2.4-4.1-1-1.2-2.3-2.1-3.8-2.8-1.5-.7-3.2-1-5.1-1s-3.7.3-5.2,1c-1.5.7-2.8,1.6-3.8,2.8-1,1.2-1.7,2.5-2.2,4.1-.5,1.6-.8,3.3-.8,5.1ZM201.5,32.1h-10.4V1.7h10.4v30.4ZM196.4,46.7c-.9,0-1.7-.2-2.4-.5-.8-.3-1.5-.7-2-1.3-.6-.6-1-1.3-1.3-2-.3-.8-.4-1.6-.4-2.4,0-1.7.6-3.2,1.8-4.4,1.2-1.2,2.7-1.8,4.5-1.8s3.2.6,4.4,1.8c1.2,1.2,1.8,2.7,1.8,4.4s-.2,1.7-.5,2.4c-.3.7-.7,1.4-1.3,2-.6.6-1.2,1-2,1.3-.7.3-1.5.5-2.4.5Z');
const BINGO_PATH_WIDTH = 203;
const BINGO_PATH_HEIGHT = 47;

const SPARKLES_VARIANT_A = [{
  x: 110,
  y: 30,
  start: 0.1
}, {
  x: 110,
  y: 30,
  start: 0.4
}, {
  x: 110,
  y: 30,
  start: 0.8
}, {
  x: -80,
  y: -45,
  start: 0.1
}, {
  x: -80,
  y: -45,
  start: 0.3
}, {
  x: -80,
  y: -45,
  start: 0.6
}, {
  x: -65,
  y: 45,
  start: 0.22
}, {
  x: -65,
  y: 45,
  start: 0.45
}, {
  x: -65,
  y: 45,
  start: 0.65
}];
const SPARKLES_VARIANT_B = [{
  x: -120,
  y: 28,
  start: 0.1
}, {
  x: -120,
  y: 28,
  start: 0.4
}, {
  x: -120,
  y: 28,
  start: 0.7
}, {
  x: 74,
  y: -42,
  start: 0.1
}, {
  x: 74,
  y: -42,
  start: 0.5
}, {
  x: 74,
  y: -42,
  start: 0.7
}, {
  x: 30,
  y: 50,
  start: 0.15
}, {
  x: 30,
  y: 50,
  start: 0.35
}, {
  x: 30,
  y: 50,
  start: 0.75
}, {
  x: -16,
  y: -48,
  start: 0.2
}, {
  x: -16,
  y: -48,
  start: 0.38
}, {
  x: -16,
  y: -48,
  start: 0.67
}];
const DRAW_DEBUG = false;

const drawDebugProgress = (ctx, progress) => {
  if (!DRAW_DEBUG) {
    return;
  }
  ctx.resetTransform();
  ctx.fillStyle = '#00ff00';
  ctx.fillRect(0, 0, ctx.canvas.width * progress, 3);
};
const drawDebugGrid = ctx => {
  if (!DRAW_DEBUG) {
    return;
  }
  ctx.strokeStyle = '#0000ff';
  ctx.beginPath();
  for (let i = 0.0; i < 10.0; i++) {
    const offset = i / 10.0;
    ctx.moveTo(-ctx.canvas.width * 0.5, offset * ctx.canvas.height);
    ctx.lineTo(ctx.canvas.width * 0.5, offset * ctx.canvas.height);
    ctx.moveTo(-ctx.canvas.width * 0.5, offset * -ctx.canvas.height);
    ctx.lineTo(ctx.canvas.width * 0.5, offset * -ctx.canvas.height);
    ctx.moveTo(offset * ctx.canvas.width, -ctx.canvas.height * 0.5);
    ctx.lineTo(offset * ctx.canvas.width, ctx.canvas.height * 0.5);
    ctx.moveTo(offset * -ctx.canvas.width, -ctx.canvas.height * 0.5);
    ctx.lineTo(offset * -ctx.canvas.width, ctx.canvas.height * 0.5);
  }
  ctx.stroke();
  ctx.strokeStyle = '#00ff00';
  ctx.strokeRect(-ctx.canvas.width * 0.5, -ctx.canvas.height * 0.5, ctx.canvas.width, ctx.canvas.height);
};

const drawBackground = (ctx, progress) => {
  ctx.resetTransform();

  ctx.fillStyle = "rgba(201, 20, 133, ".concat(remapTime(progress, 0.00, 0.05), ")");
  ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
};
const drawBingoText = (ctx, progress, totalTime) => {
  const DURATION = 400; 
  progress = remapTime(progress, 0.05, 0.05 + DURATION / totalTime);
  if (progress <= 0.0) {
    return;
  }
  const scale = lerp(0.7, 1.0, easeOutBounce(progress));
  ctx.scale(scale, scale);
  ctx.translate(-BINGO_PATH_WIDTH * 0.5, -BINGO_PATH_HEIGHT * 0.5);
  ctx.translate(8, 0);
  ctx.fillStyle = '#ffffff';
  ctx.fill(BINGO_PATH);
};

const drawIndividualSparkle = (ctx, progress, magnitude, minLength, maxLength) => {
  const startX = magnitude * progress;
  const length = lerp(minLength, maxLength, progress);
  ctx.beginPath();
  ctx.moveTo(startX, 0);
  ctx.lineTo(startX + length, 0);
  ctx.stroke();
};
const drawSparkleVariantA = (ctx, progress, totalTime, sparkle) => {
  const WIDTH = 3.0;
  const WIDTH_SECONDARY = 2.0;
  const DURATION = 300; 

  ctx.translate(sparkle.x, sparkle.y);

  const progressPrimary = remapTime(progress, sparkle.start, sparkle.start + DURATION / totalTime);
  if (progressPrimary > 0.0 && progressPrimary < 1.0) {
    ctx.lineWidth = WIDTH;
    ctx.lineCap = 'round';
    for (let i = 0; i < 4; i++) {
      drawIndividualSparkle(ctx, progressPrimary, 24.0, 12.0, 4.0);
      ctx.rotate(Math.PI * 2 / 4);
    }
  }

  const progressSecondary = remapTime(progressPrimary, 0.0, 0.75);
  if (progressSecondary > 0.0 && progressSecondary < 1.0) {
    ctx.rotate(45 * Math.PI / 180);
    ctx.lineWidth = WIDTH_SECONDARY;
    for (let i = 0; i < 2; i++) {
      drawIndividualSparkle(ctx, progressSecondary, 20.0, 8.0, 4.0);
      ctx.rotate(Math.PI);
    }
  }
};
const drawSparkleVariantB = (ctx, progress, totalTime, sparkle) => {
  const WIDTH = 4.0;
  const DURATION = 350; 

  ctx.translate(sparkle.x, sparkle.y);

  const progressPrimary = remapTime(progress, sparkle.start, sparkle.start + DURATION / totalTime);
  if (progressPrimary > 0.0 && progressPrimary < 1.0) {
    ctx.lineWidth = WIDTH;
    ctx.lineCap = 'round';
    for (let i = 0; i < 5; i++) {
      drawIndividualSparkle(ctx, progressPrimary, 28.0, 16.0, 2.0);
      ctx.rotate(Math.PI * 2 / 5);
    }
  }

  const progressStar = remapTime(progressPrimary, 0.0, 0.8);
  if (progressStar > 0.0 && progressStar < 1.0) {
    const STAR_SIZE_MAX = 10.0;
    const STAR_SIZE_MIN = 2.0;
    const STAR_SIZE_RATIO = 0.5;
    ctx.lineWidth = WIDTH * 0.75;
    ctx.beginPath();
    for (let i = 0; i < 5; i++) {
      ctx.lineTo(lerp(STAR_SIZE_MIN, STAR_SIZE_MAX, progressStar), 0);
      ctx.rotate(Math.PI * 2 / 10);
      ctx.lineTo(lerp(STAR_SIZE_MIN * STAR_SIZE_RATIO, STAR_SIZE_MAX * STAR_SIZE_RATIO, progressStar), 0);
      ctx.rotate(Math.PI * 2 / 10);
    }
    ctx.closePath();
    ctx.stroke();
  }
};
const drawFireworks = (ctx, progress, totalTime) => {
  ctx.strokeStyle = '#ffffff';
  for (const sparkle of SPARKLES_VARIANT_A) {
    ctx.save();
    drawSparkleVariantA(ctx, progress, totalTime, sparkle);
    ctx.restore();
  }
  for (const sparkle of SPARKLES_VARIANT_B) {
    ctx.save();
    drawSparkleVariantB(ctx, progress, totalTime, sparkle);
    ctx.restore();
  }
};


const DRAW_COMMANDS = [drawBackground, drawDebugProgress, drawDebugGrid, drawBingoText, drawFireworks];
const drawWinAnim = (ctx, progress, totalTime) => {
  ctx.resetTransform();

  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

  ctx.setTransform(1, 0, 0, 1, ctx.canvas.width * 0.5, ctx.canvas.height * 0.5);

  ctx.globalAlpha = 1.0 - remapTime(progress, 0.95, 1.0);
  for (const drawCommand of DRAW_COMMANDS) {
    ctx.save();
    drawCommand(ctx, progress, totalTime);
    ctx.restore();
  }
};
setGlobal('svs.bingo_react.components.bingoCard.canvas.drawWinAnim', drawWinAnim);

 })(window);